const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

const getImageDimension = file =>
  new Promise((resolve, reject) => {
    var url = URL.createObjectURL(file);
    const img = new Image();
    img.src = url;

    img.onload = () =>
      resolve({
        width: img.width,
        height: img.height
      });

    img.onerror = error => reject(error);
  });

export { toBase64, getImageDimension };
